import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { themr } from 'react-css-themr';

import styles from './styles.scss';

const Card = (props) => {
  const { theme, altColor, inactive, className, children, ...otherprops } = props;

  const cardStyles = cx({
    [theme.card]: true,
    [theme.inactive]: inactive,
    [theme.altColor]: altColor,
    [props.className]: className,
  });

  return (
    <div className={cardStyles} {...otherprops}>
      {children}
    </div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  altColor: PropTypes.bool,
  inactive: PropTypes.bool,
  theme: PropTypes.shape({
    card: PropTypes.string,
    inactive: PropTypes.string,
    altColor: PropTypes.string,
  }),
  children: PropTypes.node,
};

export default themr('Card', styles)(Card);



// WEBPACK FOOTER //
// ./client/app/shared/components/Card/index.jsx